//Role Based Access Control Helper
import store from './store';

import { ACCESS_CONTROL, ACTIONS, RESOURCES } from './roles';

const RBACHelper = {};

RBACHelper.ACTIONS = ACTIONS;

RBACHelper.RESOURCES = RESOURCES;

RBACHelper.validateRoleBasedAccess = function (action, resource) {
	return new Promise((resolve, reject) => {
		try {
			let roles = store.state.account_info.roles;

			if (roles == undefined) {
				return false;
			} //Reject if the role is not given
			if (resource == undefined) {
				return false;
			} //Reject if the resource is not given

			const permission = ACCESS_CONTROL.can(roles)[action](resource);

			// console.log('Role is allowed', JSON.stringify(ACCESS_CONTROL.can(roles), null, 4))

			if (permission.granted != true) {
				//Not authorized to access this content - reject
				return reject({ reason: 'INVALID_PERMISSIONS', permissions: permission });
			}

			return resolve({ permissions: permission });
		} catch (error) {
			console.log('Error validating RBA', error);
			return reject({ reason: 'INVALID_PERMISSIONS', error });
		}
	});
};

RBACHelper.validateRBC = RBACHelper.validateRoleBasedAccess;

RBACHelper.canUserAccessResource = function (action, resource) {
	try {
		let roles = store.state.account_info.roles;

		if (roles == undefined) {
			return false;
		} //Reject if the role is not given
		if (resource == undefined) {
			return false;
		} //Reject if the resource is not given

		const permission = ACCESS_CONTROL.can(roles)[action](resource);

		if (permission.granted != true) {
			return false;
		} //Not authorized to access this content - reject
		return true;
	} catch (error) {
		console.log('Error validating RBA', error);
		return false;
	}
};

RBACHelper.validateRoleBasedAccessForAttributes = function (action, resource, attributes, user_role) {
	return new Promise((resolve, reject) => {
		try {
			const permission = ACCESS_CONTROL.can(user_role)[action](resource);

			// console.log('Role is allowed', JSON.stringify(ACCESS_CONTROL.can(user_role), null, 4))

			if (permission.granted != true) {
				//Not authorized to access this content - reject
				return reject({ reason: 'INVALID_PERMISSIONS', permissions: permission });
			}

			console.log('action', action, resource, user_role);
			console.log('attributes', permission.attributes, 'needed attributes', attributes);
			for (const attribute of attributes) {
				console.log('1', permission.attributes.includes(attribute), '2', permission.attributes.includes(`!${attribute}`), '3', permission.attributes.includes('*'));
				if ((permission.attributes.includes(attribute) == false && permission.attributes.includes('*') == false) || permission.attributes.includes(`!${attribute}`) == true) {
					//Check if the given attribute is included in the list as well as it is explicitly not set and there is no wildcard.
					return reject({ reason: 'INVALID_PERMISSIONS_FOR_ATTRIBUTES', permissions: permission });
				}
			}

			// req.permissions = permission;
			// next();
		} catch (error) {
			console.log('Error validating RBA for attributes', error);
			return reject({ reason: 'INVALID_PERMISSIONS', error });
		}
	});
};

RBACHelper.validateRBCForAttributes = RBACHelper.validateRoleBasedAccessForAttributes;

export default RBACHelper;
